import { useContext, useState } from 'react';

import { RichText, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { ModalContext } from 'src/context/Modal/ModalContext';

import { FetchState } from 'src/enums/FetchState';
import { LoginContent } from 'src/enums/loginContent';

import useContentAccessLevel from 'src/hooks/useContentAccessLevel';

import { parseAccessLevelContent } from 'src/mappers/fields/parseAccessLevelContent';

import { ContentAccessTypeItem } from 'src/types/ContentAccessTypeItem';

import LoginFields from 'src/components/account/Login/_Fields/LoginFields';
import { SecureSignInForm } from 'src/components/account/Login/_SecureSignInForm/_SecureSignInForm';
import richTextStyles from 'src/components/basicContent/_RichText/RichText.module.css';

import { LoginHeader } from './_Header/LoginHeader';

import { LoginFormFields } from './LoginFormFields';

import styles from './Login.module.css';

export type loginProps = {
	fields: LoginFormFields & {
		AccessType?: Array<ContentAccessTypeItem>;
	};
	loginBtnColour?: string;
	redirectUrl?: string;
	disableUrlRedirect?: boolean;
	params: {
		displayBlurredContent: 'false' | 'true';
	};
};

export default function Login(props: loginProps) {
	const ModalState = useContext(ModalContext);
	const access = parseAccessLevelContent(props.fields?.AccessType, props.fields);
	const contentAccessLevel = useContentAccessLevel(access);

	const [loginContent, setLoginContent] = useState(LoginContent.LOGIN);
	const [loginState, setLoginState] = useState(FetchState.START);

	const mergedContentAccessLevel =  { ...contentAccessLevel, ...ModalState.modalInfo?.LoginFormModal?.Data?.contentAccessLevel };

	return (
		<div className={`${richTextStyles.richText} ${props.params?.displayBlurredContent === 'true' ? styles.backdrop : ''}`}>
			{loginContent === LoginContent.LOGIN && (
				<>
					<LoginHeader fields={props.fields} contentAccessLevel={mergedContentAccessLevel} />

					<LoginFields
						redirectUrl={props.redirectUrl}
						fields={props.fields}
						contentAccessLevel={mergedContentAccessLevel}
						loginBtnColour={props.loginBtnColour}
						disableUrlRedirect={props.disableUrlRedirect}
						loginState={loginState}
						setLoginState={setLoginState}
						setLoginContent={setLoginContent}
					/>

					<hr className={styles.hr} />

					{mergedContentAccessLevel.isNonMemberViewingMemberContent ? (
						<div>
							<RichText className={styles.inline} field={props.fields.NonMemberLoggedInAvailableContentText} />

							{props.fields.OverviewPageLinkTextInFooter && props.fields.OverviewPageLink?.url && (
								<>
									{props.fields.OverviewPageAdditionalTextInFooter && (
										<>
											<Text tag="span" field={props.fields.OverviewPageAdditionalTextInFooter} />
										</>
									)}
									<a href={props.fields.OverviewPageLink.url}>
										<Text field={props.fields.OverviewPageLinkTextInFooter} />
									</a>
								</>
							)}
						</div>
					) : mergedContentAccessLevel.isNonSubscriberViewingSubscriberContent ? (
						<div>
							<RichText className={styles.inline} field={props.fields.NonSubscriberLoggedInAvailableContentText} />

							{props.fields.OverviewPageLinkTextInFooter && props.fields.OverviewPageLink?.url && (
								<>
									{props.fields.OverviewPageAdditionalTextInFooter && (
										<>
											<Text tag="span" field={props.fields.OverviewPageAdditionalTextInFooter} />
										</>
									)}
									<a href={props.fields.OverviewPageLink.url}>
										<Text field={props.fields.OverviewPageLinkTextInFooter} />
									</a>
								</>
							)}
						</div>
					) : (
						<></>
					)}

					{mergedContentAccessLevel.isRcnMemberContent ? (
						<div>
							<RichText field={props.fields.MemberLoginFootnote} />
						</div>
					) : mergedContentAccessLevel.isRcniPlusSubscriberContent ? (
						<div>
							<RichText field={props.fields.SubscriberLoginFootnote} />
						</div>
					) : mergedContentAccessLevel.isRegisteredUserContent ? (
						<div>
							<RichText field={props.fields.RegisteredLoginFootnote} />
						</div>
					) : (
						<></>
					)}
				</>
			)}

			{loginContent === LoginContent.SUPPORT_OPTIONS && (
				<RichText
					field={props.fields.LoginSupportModalText}
					className={`${richTextStyles.richText} white ${richTextStyles.richText} ${richTextStyles.supportModalContent}`}
				/>
			)}

			{loginContent === LoginContent.SECURE_LOG_IN && (
				<SecureSignInForm
					usernamePattern={props.fields.UsernamePattern}
					SecureLoginLinkIntroText={props.fields.SecureLoginLinkIntroText}
					SecureLoginLinkUsernameLabel={props.fields.SecureLoginLinkUsernameLabel}
					SecureLoginLinkButtonText={props.fields.SecureLoginLinkButtonText}
					SecureLoginLinkSuccessText={props.fields.SecureLoginLinkSuccessText}
					SecureLoginLinkErrorText={props.fields.SecureLoginLinkErrorText}
				/>
			)}
		</div>
	);
}
